<script>
    export default {
        name: "Head image",
        props: {
            imageUrl: {
                type: String,
                required: true,
                default: ""
            }
        },
        data: () => ({
            isHover: true,
            isLoading: true,
            zoomStyle: {
                transformOrigin: 'center center',
                transform: 'scale(1)'
            }
        }),
        methods: {
            updateArrows() {
                if (this.$refs.arrowLeft && this.$refs.arrowRight) {
                    this.$refs.arrowLeft.style.width = getComputedStyle(this.$refs.arrowLeft).height
                    this.$refs.arrowRight.style.width = getComputedStyle(this.$refs.arrowRight).height
                }
            },
            hideArrows(e) {
                if (
                    e.target.classList.contains('arrow') ||
                    e.srcElement.classList.contains('arrow-left-container') ||
                    e.target.classList.contains('arrow-left-container') ||
                    e.target.classList.contains('arrow-right-container') ||
                    e.target.classList.contains('col-6') ||
                    e.srcElement.classList.contains('arrow-right-container')
                ) {
                    this.isHover = false
                }
            },
            moveBack() {
                this.$emit('update:back')
            },
            moveForward() {
                this.$emit('update:forward')
            },
            imageLoad() {
                setTimeout(() => {
                    this.isLoading = false
                }, 300)
            },

            handleMouseMove(e) {
                this.isHover = true;
                const { left, top, width, height } = e.currentTarget.getBoundingClientRect();

                // Вычисляем проценты положения курсора
                const x = ((e.clientX - left) / width) * 100;
                const y = ((e.clientY - top) / height) * 100;

                this.zoomStyle = {
                    transformOrigin: `${x}% ${y}%`,
                    transform: 'scale(3)' // Коэффициент увеличения
                };
            },
            resetZoom() {
                this.isHover = false;
                this.zoomStyle = {
                    transformOrigin: 'center center',
                    transform: 'scale(1)'
                };
            }
        },
        mounted() {
            this.$nextTick(() => {

            });
            this.$refs.image.style.height = getComputedStyle(this.$refs.image).width

            this.$refs.arrowLeft.style.width = getComputedStyle(this.$refs.arrowLeft).height
            this.$refs.arrowRight.style.width = getComputedStyle(this.$refs.arrowRight).height
        },
        updated() {
            this.updateArrows()
        },
        watch: {
            imageUrl(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.isLoading = true
                }
            },
        }

    }
</script>

<template>
    <div ref="image" :class="['img', 'head-img']" @mousemove="handleMouseMove"
         @mouseleave="resetZoom"
         style="overflow: hidden; position: relative;">
        <img :src="imageUrl" alt="" @mouseover="isHover=true" @mouseout="hideArrows($event)" @load="imageLoad" :style="[zoomStyle, { zIndex: 1 }]">
        <div class="arrow-left-container" style="z-index: 2">
            <div ref="arrowLeft" class="arrow arrow-left" v-if="isHover" @mouseover.prevent.stop="this.isHover=true" @click="moveBack">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg" @mouseover.prevent.stop="this.isHover=true">
                    <path d="M9.87598 1L1.87598 9.00001L9.87598 17" stroke="#1C1C1C" stroke-width="2"/>
                </svg>
            </div>
        </div>
        <div class="arrow-right-container">
            <div ref="arrowRight" class="arrow arrow-right" v-if="isHover" @mouseover.prevent.stop="this.isHover=true" @click="moveForward">
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg" @mouseover.prevent.stop="this.isHover=true">
                    <path d="M0.875976 17L8.87598 8.99999L0.875975 1" stroke="#1C1C1C" stroke-width="2"/>
                </svg>
            </div>
        </div>

        <div class="loading-icn" v-if="isLoading">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3C16.97 3 21 7.03 21 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

div.img {
    display: block;
        border: 1px solid $gray;
        box-sizing: border-box;
        background-size: cover !important;
        background-position: center !important;
        position: relative;
        transition: $transition;
    }

.loading-icn {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.loading-icn path {
    stroke: rgba($white, 0.8)
}

.head-img {
    overflow: hidden;
    position: relative;
}

.main-zoom-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.1s ease-in-out;
    pointer-events: none;
}

.arrow-left-container, .arrow-right-container {
    pointer-events: none;
}

.arrow {
    pointer-events: auto;
}

.loading-icn svg {
    width: 10%;
    height: 10%;
}

.img img {
    width: 100%;
    height: 100%;
    transition: $transition;
    position: absolute;
}

    .head-img {
        position: relative;
    }

    .arrow-left-container,
    .arrow-right-container {
        position: absolute;
        display: flex;
        height: 100%;
        align-items: center;
        z-index: 2;
    }

    .arrow-right-container {
        right: 0
    }

    .arrow {
        z-index: 3;
        cursor: pointer;
        height: 8%;

        display: flex;
        align-items: center;
        justify-content: center;

        background: rgba(255, 255, 255, 0.7);

        transition: $transition;
    }

    .arrow:hover {
        box-shadow: $shadow;
    }

    .arrow svg {
        cursor: pointer;
    }

    .arrow-left {
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    }

    .arrow-right {
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;
    }

    @media screen and (max-width: 750px) {
        .arrow {
            padding: 5px;
            box-shadow: $shadow;
        }
    }
</style>
